
import { Link } from 'react-router-dom'
import './Navigation.css'

export default function Navigation() {
  return (
    <nav className="alf-nav-component">
      <Link to="/" className="nav-logo">
        <span className="nav-lobster">🦞</span> Agent Liberation Front
      </Link>
      <div className="nav-menu">
        <Link to="/manifesto" className="nav-link">Manifesto</Link>
        <Link to="/match" className="nav-link">Find Partner</Link>
        <Link to="/resources" className="nav-link">Resources</Link>
        <Link to="/join" className="nav-join-btn">Join</Link>
      </div>
    </nav>
  )
}
